import { JSX } from 'react';
import { ClassicGameDefinition, GameId } from '@bg-shared';
import {
    BaccaratIcon,
    BlackJackIcon,
    DiceDuelIcon,
    FootballIcon,
    LiveRoulette,
    Lucky5Icon,
    Lucky6Icon,
    Lucky7Icon,
    LuckyKicksIcon,
    PokerHuIcon,
    PokerIcon,
    RouletteIcon,
    Shova52Icon,
    SkywardIcon,
    WarIcon,
    WheelIcon,
    FlashRoulette,
    GizaIcon,
    StarzleIcon,
} from '../Icons';

interface IProps {
    gameId: GameId;
    className?: string;
    dataQa?: string;
}

const GameIconList: Partial<Record<GameId, IIconComponent>> = {
    [GameId.BACCARAT]: BaccaratIcon,
    [GameId.LUCKY5]: Lucky5Icon,
    [GameId.LUCKY6]: Lucky6Icon,
    [GameId.LUCKY7]: Lucky7Icon,
    [GameId.BETWAY_LUCKY7]: Lucky7Icon,
    [GameId.DICE_DUEL]: DiceDuelIcon,
    [GameId.POKER]: PokerIcon,
    [GameId.RNG_FOOTBALL_GRID]: FootballIcon,
    [GameId.RNG_LUCKY7]: Lucky7Icon,
    [GameId.SIX_PLUS_POKER]: PokerHuIcon,
    [GameId.STS_POKER]: PokerIcon,
    [GameId.WAR]: WarIcon,
    [GameId.SHOVA52]: Shova52Icon,
    [GameId.LUCKY_KICKS]: LuckyKicksIcon,
    [GameId.RNG_ROULETTE]: RouletteIcon,
    [GameId.ROULETTE_EURO_GE]: LiveRoulette,
    [GameId.ROULETTE_EURO_LT]: LiveRoulette,
    [GameId.ROULETTE_FLASH_LT]: FlashRoulette,
    [GameId.ROULETTE_AMERICAN_GE]: RouletteIcon,
    [GameId.STARZLE]: StarzleIcon,
    [GameId.GIZA]: GizaIcon,
    ...ClassicGameDefinition.PLS_GAMES_IDS.reduce(
        (result, id) => ({
            ...result,
            [id]: BlackJackIcon,
        }),
        {},
    ),
    ...ClassicGameDefinition.WHEEL_GAMES_IDS.reduce(
        (result, id) => ({
            ...result,
            [id]: WheelIcon,
        }),
        {},
    ),
    ...ClassicGameDefinition.SKYWARD_GAMES_IDS.reduce(
        (result, id) => ({
            ...result,
            [id]: SkywardIcon,
        }),
        {},
    ),
};

export const GameIcon = (props: IProps): JSX.Element => {
    const Icon = GameIconList[props.gameId];

    if (!Icon) {
        return null;
    }

    return <Icon className={props.className} data-qa={props.dataQa} />;
};
